import { jsx as _jsx } from "react/jsx-runtime";
import { TransitionPaletteContext } from '@/components/molecules/TransitionPalette/TransitionPaletteContext';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { forwardRef, useContext } from 'react';
export const paletteVariants = cva('', {
    variants: {
        palette: {
            none: '',
            'palette-light': 'palette-light',
            'palette-dark': 'palette-dark',
            'palette-partial': 'palette-partial',
            'palette-highlight': 'palette-highlight',
        },
    },
    defaultVariants: {
        palette: 'none',
    },
});
const layoutContainerVariants = cva('', {
    variants: {
        spacing: {
            none: '',
            standard: 'px-gutter py-12 @md:p-gutter-md @2xl:p-gutter-2xl-vw',
            standardFooter: 'px-gutter py-12 @md:px-gutter-md lg:py-14 @2xl:px-gutter-2xl-vw',
            moreOnSmall: 'px-gutter py-12 @xs:px-gutter-md lg:py-14 @2xl:px-gutter-2xl-vw',
        },
        spacingX: {
            none: '',
            standard: 'px-gutter @md:px-gutter-md @2xl:px-gutter-2xl',
            'standard-margin': 'mx-gutter @md:mx-gutter-md @2xl:mx-gutter-2xl',
        },
        spacingY: {
            none: '',
            large: 'py-38',
            standard: 'my-12',
        },
        headerUnderlay: {
            false: '',
            true: 'pt-18 @md:pt-24',
        },
        grid: {
            false: '',
            true: 'gap-x-grid-gutter @md:gap-x-grid-gutter-md grid grid-cols-6 @md:grid-cols-12',
        },
        palette: {
            none: '',
            'palette-light': `bg-surface-primary-default text-type-default ${paletteVariants({ palette: 'palette-light' })}`,
            'palette-dark': `bg-surface-primary-default text-type-default ${paletteVariants({ palette: 'palette-dark' })}`,
            'palette-partial': `bg-surface-primary-default text-type-default ${paletteVariants({ palette: 'palette-partial' })}`,
            'palette-highlight': `bg-surface-primary-default text-type-default ${paletteVariants({ palette: 'palette-highlight' })}`,
        },
        constrainAndCenter: {
            none: '',
            large: 'mx-auto max-w-450',
            small: 'mx-auto max-w-261.5',
        },
    },
    defaultVariants: {
        spacing: 'none',
        grid: false,
        palette: 'none',
        constrainAndCenter: 'none',
    },
});
const LayoutContainer = forwardRef(({ children, className, spacing, grid, palette, constrainAndCenter, spacingX, spacingY, headerUnderlay, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'section';
    const insideTransitionPalette = useContext(TransitionPaletteContext);
    const dataPalette = insideTransitionPalette && palette != null && palette !== 'none' ? palette : undefined;
    return (_jsx(TransitionPaletteContext.Provider, { value: false, children: _jsx(Comp, { ref: ref, "data-palette": dataPalette, className: layoutContainerVariants({
                spacing,
                grid,
                palette: insideTransitionPalette ? 'none' : palette,
                constrainAndCenter,
                spacingX,
                spacingY,
                headerUnderlay,
                className,
            }), ...props, children: children }) }));
});
export { LayoutContainer, layoutContainerVariants };
